export default __webpack_public_path__ + "static/media/Flag_of_Malawi.642964a1.svg";